import { securedAxiosInstance } from "../axios";

class QuickSearchService {
  search(keywords, options = {}) {
    return securedAxiosInstance.get("/quick_search", {
      params: { keywords },
      ...options,
    });
  }
}

export default new QuickSearchService();
